import React from 'react'
import PropTypes from 'prop-types'

import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import makeStyles from '@material-ui/core/styles/makeStyles'

import icoDocumentNotFound from '../../../assets/img/icons/icon-document-not-found.svg'

import { ButtonLight, ButtonGradient, ModalInfo } from '../../../shared/components'

const useStyles = makeStyles((theme) => ({
  buttonsStep: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(2),
    '& .MuiBox-root': {
      minWidth: 190,
    },
    '@media (max-width: 699px)': {
      justifyContent: 'center',
    },
  },
  modal: {
    '& .MuiPaper-root': {
      maxWidth: 600,
    },
  },
}))

const ModalPolicyIsUpload = (props) => {
  const classes = useStyles()
  const {
    openModal,
    closeModal,
    documentNumber,
    resetFieldsDocument,
    setDocumentIsUpload,
  } = props

  return (
    <>
      {openModal && (
        <ModalInfo
          close={false}
          open={openModal}
          className={classes.modal}
        >
          <Box p={2} alignItems="center" justifyContent="center">
            <Box>
              <Box flexGrow={1} textAlign="center">
                <img width={150} src={icoDocumentNotFound} alt="" />
              </Box>
              <Box mt={2}>
                <Typography align="center" variant="h6"> Este documento foi emitido por outra corretora.</Typography>
              </Box>
              <Box mb={2} alignItems="center" justifyContent="center">
                {' '}
              </Box>
              <Box mb={5} width="100%" display="flex" textAlign="center" justifyContent="center">
                <Typography align="center" variant="h6" style={{ fontSize: 18 }}>
                  Número documento
                </Typography>
                <Typography style={{
                  fontSize: 18,
                  marginTop: 2,
                  marginLeft: 10,
                  color: '#5785DC',
                }}
                >
                  {documentNumber}
                </Typography>
              </Box>
              <Grid item xs={12}>
                <Box justifyContent="center" className={classes.buttonsStep}>
                  <Box>
                    <ButtonLight
                      onClick={() => {
                        resetFieldsDocument()
                        closeModal(true)
                      }}
                    >
                      Cancelar
                    </ButtonLight>
                  </Box>
                  <Box>
                    <ButtonGradient
                      onClick={() => {
                        closeModal(true)
                        setDocumentIsUpload(true)
                      }}
                    >
                      Seguir com Solicitação
                    </ButtonGradient>
                  </Box>
                </Box>
              </Grid>
            </Box>
          </Box>
        </ModalInfo>
      )}
    </>
  )
}

ModalPolicyIsUpload.propTypes = {
  openModal: PropTypes.bool.isRequired,
  resetFieldsDocument: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  documentNumber: PropTypes.string,
  setDocumentIsUpload: PropTypes.func.isRequired,
}
ModalPolicyIsUpload.defaultProps = {
  documentNumber: '',
}

export default ModalPolicyIsUpload
